import { render, staticRenderFns } from "./SoilAnalysisReportDetails.vue?vue&type=template&id=33b6505d&scoped=true"
import script from "./SoilAnalysisReportDetails.vue?vue&type=script&lang=js"
export * from "./SoilAnalysisReportDetails.vue?vue&type=script&lang=js"
import style0 from "./SoilAnalysisReportDetails.vue?vue&type=style&index=0&id=33b6505d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b6505d",
  null
  
)

export default component.exports